import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PCIService {
  OBPortalSvcURL = '';
  busSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getBookingHash(BookingCode: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const BookingInfo: JSON = <JSON>(<unknown>{
      BookingCode: BookingCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetHashFromBookingCode',
      JSON.stringify(BookingInfo),
      { headers: headers }
    );
  }
  public getPCIData(
    rebcode: string | undefined,
    foliolist:
      | {
          FolioId: number;
        }[] = []
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const PCIInfo: JSON = <JSON>(<unknown>{
      bookingCode: rebcode,
      FolioList: foliolist,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetPCI',
      JSON.stringify(PCIInfo),
      { headers: headers }
    );
  }
}
